<script setup lang="ts">
import PageMeta from "../../components/PageMeta";
import TopLink from "../../components/ui/TopLink.vue";
</script>

<template>
  <PageMeta
    title="Accessibilité"
    description="Déclaration d’accessibilité du site ara.numerique.gouv.fr"
  />
  <section class="fr-my-0 fr-mx-auto content">
    <h1>Déclaration d’accessibilité</h1>
    <p><strong>La Direction Interministérielle du Numérique</strong> s’engage à rendre ses sites internet, intranet, extranet et ses progiciels accessibles (et ses applications mobiles et mobilier urbain numérique) conformément à l’article 47 de la loi n<sup>o</sup>&nbsp;2005-102 du 11&nbsp;février 2005.</p>
    <p>Cette déclaration d’accessibilité s’applique à <a href="https://ara.numerique.gouv.fr">Ara</a>.</p>
    <h2>État de conformité</h2>
    <p><strong>Ara</strong> est <strong>totalement conforme</strong> avec le référentiel général d’amélioration de l’accessibilité (RGAA).</p>
    <h3>Résultats des tests</h3>
    <p>L’audit de conformité réalisé par <strong>la Brigade d'Intervention du Numérique de la DINUM</strong> révèle que <strong>100&nbsp;%</strong> des critères du RGAA version 4.1.2 sont respectés.</p>
    <h2> Établissement de cette déclaration d’accessibilité </h2>
    <p>Cette déclaration a été établie le <strong>23 avril 2025</strong>. Elle a été mise à jour le <strong>9 octobre 2025</strong>.</p>
    <h3>Technologies utilisées pour la réalisation du site</h3>
    <ul>
      <li>HTML</li>
      <li>CSS</li>
      <li>Javascript</li>
    </ul>
    <h3>Environnement de test</h3>
    <p>Les vérifications de restitution de contenus ont été réalisées sur la base de la combinaison fournie par la base de référence du RGAA, avec les versions suivantes&nbsp;:</p>
    <ul>
      <li> Sur Mobile iOS avec Safari et VoiceOver</li>
      <li> Sur Ordinateur MacOS avec Safari et VoiceOver</li>
      <li> Sur Ordinateur Windows avec Firefox et JAWS</li>
      <li> Sur Ordinateur Windows avec Firefox et NVDA</li>
    </ul>
    <h3>Outils pour évaluer l’accessibilité</h3>
    <ul>
      <li>Web Developer Toolbar</li>
      <li>Colour Contrast Analyser</li>
      <li>HeadingsMap</li>
      <li>WCAG Contrast checker</li>
      <li>Inspecteur de composants</li>
      <li>Validateur HTML du W3C</li>
    </ul>
    <h3>Pages du site ayant fait l’objet de la vérification de conformité</h3>
    <ul>
      <li>Accueil <strong>https://ara.numerique.gouv.fr/</strong></li>
      <li>Contact et contributions <strong>https://ara.numerique.gouv.fr/contact-contributions</strong></li>
      <li>Mentions légales <strong>https://ara.numerique.gouv.fr/mentions-legales</strong></li>
      <li>Accessibilité <strong>https://ara.numerique.gouv.fr/accessibilite</strong></li>
      <li>Plan du site <strong>https://ara.numerique.gouv.fr/plan-du-site</strong></li>
      <li>Connexion <strong>https://ara.numerique.gouv.fr/compte/connexion</strong></li>
      <li>Mot de passe oublié <strong>https://ara.numerique.gouv.fr/compte/reinitialiser-mot-de-passe</strong></li>
      <li>Compte <strong>https://ara.numerique.gouv.fr/compte/parametres</strong></li>
      <li>Mes audits <strong>https://ara.numerique.gouv.fr/compte</strong></li>
      <li>Synthèse <strong>https://ara.numerique.gouv.fr/audits/xxx/synthese</strong></li>
      <li>Audit <strong>https://ara.numerique.gouv.fr/audits/xxx/generation</strong></li>
      <li>Rapport <strong>https://ara.numerique.gouv.fr/rapport/xxx/resultats</strong></li>
      <li>Déclaration (saisie) <strong>https://ara.numerique.gouv.fr/audits/xxx/declaration</strong></li>
      <li>Déclaration (consultation) <strong>https://ara.numerique.gouv.fr/declaration/xxx</strong></li>
      <li>Paramètre de l'audit <strong>https://ara.numerique.gouv.fr/audits/xxx/parametres</strong></li>
    </ul>
    <h2>Retour d’information et contact</h2>
    <p>Si vous n’arrivez pas à accéder à un contenu ou à un service, vous pouvez contacter l’équipe en charge d’Ara à l’adresse suivante&nbsp;: <strong>ara@design.numerique.gouv.fr</strong>.</p>
    <h2>Voies de recours</h2>
    <p>Si vous constatez un défaut d’accessibilité vous empêchant d’accéder à un contenu ou une fonctionnalité du site, que vous nous le signalez et que vous ne parvenez pas à obtenir une réponse de notre part, vous êtes en droit de faire parvenir vos doléances ou une demande de saisine au Défenseur des droits.</p>
    <p>Plusieurs moyens sont à votre disposition&nbsp;:</p>
    <ul class="fr-mb-0">
      <li><a href="https://formulaire.defenseurdesdroits.fr/formulaire_saisine" target="_blank">Écrire un message au Défenseur des droits <span class="fr-sr-only">(nouvelle fenêtre)</span></a></li>
      <li><a href="https://www.defenseurdesdroits.fr/carte-des-delegues" target="_blank">Contacter le délégué du Défenseur des droits dans votre région <span class="fr-sr-only">(nouvelle fenêtre)</span></a></li>
      <li>Envoyer un courrier par la poste (gratuit, ne pas mettre de timbre) à&nbsp;:<br><span>Défenseur des droits<br> Libre réponse 71120<br> 75342 Paris CEDEX 07</span></li>
    </ul>
    <div class="top-link">
      <TopLink />
    </div>
  </section>
</template>

<style scoped>
.content {
  max-width: 49.5rem;
}

.top-link {
  text-align: end;
}
</style>
